<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin"></div>
    </Transition>

    <v-form :name="props.formProps.formName">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab value="1">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0"
                          :header="__('Basic data')">
                    <div class="grid">

                        <FormSelect fieldName="offer_id"
                                    label="Offer"
                                    size="5"
                                    validation="required"
                                    :isFormDisabled="true"
                                    :options="select?.offers"
                                    v-model:field="crud.offer_id" />

                        <FormSelect fieldName="product_id"
                                    label="Product"
                                    size="5"
                                    validation="required"
                                    :isFormDisabled="true"
                                    :options="select?.products"
                                    v-model:field="crud.product_id" />
                        <FormSelect fieldName="unit_id"
                                    label="Unit"
                                    size="2"
                                    :options="select?.units"
                                    :isFormDisabled="true"
                                    v-model:field="crud.unit_id" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="assortment_name"
                                       label="Assortment name"
                                       size="6"
                                       :isFormDisabled="true"
                                       v-model:field="crud.assortment_name" />

                        <FormInputText fieldName="section"
                                       label="Section name"
                                       size="6"
                                       :isFormDisabled="true"
                                       v-model:field="crud.section" />
                    </div>
                    <div class="grid">
                        <FormInputNumber fieldName="price"
                                         label="Price"
                                         size="2"
                                         :minFractionDigits="2"
                                         :maxFractionDigits="2"
                                         :isFormDisabled="isFormDisabled"
                                         :blur="calculateTotal"
                                         v-model:field="crud.price" />
                        <FormInputNumber fieldName="discount"
                                         label="Discount"
                                         size="2"
                                         suffix="%"
                                         :min="0"
                                         :max="100"
                                         :isFormDisabled="isFormDisabled"
                                         :blur="calculateTotal"
                                         v-model:field="crud.discount" />

                        <FormInputNumber fieldName="quantity"
                                         label="Quantity"
                                         size="2"
                                         :minFractionDigits="2"
                                         :maxFractionDigits="2"
                                         :isFormDisabled="isFormDisabled"
                                         :blur="calculateTotal"
                                         v-model:field="crud.quantity" />
                        <FormInputNumber fieldName="total"
                                         label="Total"
                                         size="4"
                                         :minFractionDigits="2"
                                         :maxFractionDigits="2"
                                         :isFormDisabled="isFormDisabled"
                                         v-model:field="crud.total" />
                        <FormInputToggleButton fieldName="is_individual_order"
                                               label="Ind. order"
                                               size="2"
                                               :isFormDisabled="isFormDisabled"
                                               v-model:field="crud.is_individual_order" />
                    </div>

                    <div class="grid">
                        <FormEditor fieldName="description"
                                    label="Description"
                                    :isFormDisabled="isFormDisabled"
                                    v-model:field="crud.description" />
                    </div>
                    <div class="grid">
                        <FormFileUploader fieldName="files"
                                          label="Pictures"
                                          category="pictures"
                                          imgPosition="right"
                                          :allowedExtensions="['jpg', 'jpeg', 'png', 'gif']"
                                          :style="{ minWidth: '200px' }"
                                          :isFormDisabled="isFormDisabled"
                                          v-model:field="crud.files" />

                    </div>
                </TabPanel>

                <TabPanel v-if="crud.log"
                          value="1"
                          :pt="{ root: { class: 'form-tab-panel' } }">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="formProps.buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled">
            </FormButtons>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import { validation, initForm } from '@pages/Helper/crud_utils.js'
import FormInputText from '@crud/FormInputText.vue'
import FormSelect from '@crud/FormSelect.vue'
import FormInputToggleButton from '@crud/FormInputToggleButton.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormFileUploader from '@crud/FormFileUploader.vue'
import FormEditor from '@crud/FormEditor.vue'
import FormButtons from '@crud/FormButtons.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(true)
const crud = ref({})
const buttonsVisibility = ref({})

const options = ['offers', 'products', 'units'];
const select = ref(null);

// -----------------------------------------------------

onMounted(async () => {
    await initForm(props, crud, isLoading, options, select)
})

// -----------------------------------------------------

const calculateTotal = () => {
    const price = parseFloat(crud.value.price) || 0;
    const discount = parseFloat(crud.value.discount) || 0;
    const quantity = parseFloat(crud.value.quantity) || 0;

    const discountedPrice = price - (price * (discount / 100));
    crud.value.total = (discountedPrice * quantity).toFixed(2);
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
